import { render, staticRenderFns } from "./Ticket.vue?vue&type=template&id=4136c866&"
import script from "./Ticket.vue?vue&type=script&lang=js&"
export * from "./Ticket.vue?vue&type=script&lang=js&"
import style0 from "./Ticket.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports